// File#: _1_news-list-filter-by-category
(function () {

    var newsListContainer = document.getElementsByClassName('news-list__news')[0];
    if (!newsListContainer) return;
    var news = newsListContainer.children;
    var loadMoreContainer = document.getElementsByClassName('news-list__load-more')[0];
    var newsListId = newsListContainer.dataset.newslist;
    var take = newsListContainer.dataset.take;
    const categoryLabels = document.getElementsByClassName("category-label");
    window.selectedCategories = [];
    var culture = newsListContainer.dataset.culture;

    function removeItemAll(arr, value) {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    }

    function updateNewsItems(categories) {
        var categoriesCsv = categories.join(',');
        var query = new URLSearchParams({ categoriesCsv, newsListId, take, skip: 0, culture });

        fetch('/umbraco/surface/newssurface/getnews?' + query)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                console.log('Error loading news..');
                return null;
            })
            .then(data => {
                if (data) {
                    newsListContainer.innerHTML = data.partialView;
                    if (!data.canLoadMore) {
                        Util.addClass(loadMoreContainer, 'news-list__load-more--hide');
                        Util.setAttributes(newsListContainer, { 'data-skip': data.skip });
                    } else {
                        Util.setAttributes(newsListContainer, { 'data-skip': data.skip });
                        Util.removeClass(loadMoreContainer, 'news-list__load-more--loading');
                    }
                }
            })
            .catch(error => console.log(error))
    }

    for (var i = 0; i < categoryLabels.length; i++) {
        var input = categoryLabels[i].getElementsByTagName('input')[0];
        input.addEventListener("change", function (event) {
            var category = this.value;
            var label = this.parentElement;
            if (this.checked) {
                window.selectedCategories.push(category);
                label.classList.add('selected-category');
            }
            else {
                removeItemAll(window.selectedCategories, category);
                label.classList.remove('selected-category');
            }
            Util.removeClass(loadMoreContainer, 'news-list__load-more--hide');
            updateNewsItems(window.selectedCategories);
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        const filterTitle = document.querySelector('.news-list__filter-by-category-title');
        const categoryLabels = document.querySelectorAll('.category-label');

        filterTitle.addEventListener('click', function () {
            categoryLabels.forEach(label => {
                label.classList.toggle('hidden');
            });

            const icon = filterTitle.querySelector('svg');
            if (icon) {
                icon.classList.toggle('rotate');
            }
        });
    });

})();